import { createContext } from "react";
import { PaletteMode } from "@mui/material/styles";

const ThemeModeContext = createContext<
  | {
      mode: PaletteMode;
      toggleThemeMode: () => void;
    }
  | undefined
>(undefined);

export default ThemeModeContext;
